import styled from "styled-components";

export const ModalContent = styled.div`
  padding-right: 20px;

  .modal-actions {
    display: flex;
    justify-content: center;
    gap: 40px;

    button {
      width: 185px;
    }
  }

  .modal-content-info {
    margin-top: 40px;
    margin-bottom: 40px;
    line-height: 1.5;
  }

  table tbody tr td:nth-of-type(2) {
    white-space: nowrap;
  }
`;
